<template>
  <b-container style="min-height: 400px" v-if="canNavigate()">
    <b-row>
      <!-- <b-col class="justify-content-start d-flex flex-column">
        <b-card class="card-transaction" no-body>
          <b-card-header>
            <b-card-title>
              <span class="text-danger">
                <feather-icon class="mx-25" icon="PhoneIcon" size="18" />
                تواصل معنا خلال ساعات الدوام الرسمي على الأرقام التالية:
              </span>
            </b-card-title>
          </b-card-header>


          <b-card-text>
            <div>
              <table class="mt-2 w-100 table table-bordered">
                <thead>
                  <tr>
                    <th>نوع الخدمة</th>
                    <th>رقم الهاتف</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>دعم قانوني</td>

                    <td>0958606091</td>
                  </tr>

                  <tr>
                    <td>دعم قانوني</td>

                    <td>0958606093</td>
                  </tr>
                  <tr>
                    <td>أسئلة شائعة</td>

                    <td>0958606092</td>
                  </tr>
                  <tr>
                    <td>دعم تقني – استفسارات حول منصة تشارك</td>

                    <td>0958606087</td>
                  </tr>
                  <tr>
                    <td>دعم تقني – استفسارات حول منصة تشارك</td>

                    <td>0958606089</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-text>
        </b-card>
      </b-col> -->
      <!-- <b-col class="justify-content-start d-flex flex-column">
        <profile-completion
          class="d-flex flex-column"
          style="align-items: center; width: 30%"
        />
        <statistic-card
          style="width: 100%"
          class="border"
          statisticTitle="عدد مرات الظهور في نتائج البحث"
          statistic="127"
          icon="SearchIcon"
        />
        <visits-statistics class="border" />
      </b-col> -->
      <b-col cols="12"">
        <div class="d-flex w-100 justify-content-between align-items-center">
          <h3><feather-icon size="22" icon="ClockIcon" /> سجل التتبع</h3>
          <b-button
            variant="flat-info"
            @click="$router.push({ name: 'events-log' })"
            >عرض الكل</b-button
          >
        </div>
        <hr />
        <events-log :loading="loading" :events="logs"> </events-log>
      </b-col>
    </b-row>
    
    
    <!-- TransactionsStatistics -->
    <b-modal
      v-model="isTransactionsStatisticsShow"
      centered
      title="تنويه"
      footer-class="removed"
      class="edit-modal"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
    >
      <div class="cropper-container">
        <h4>
          لديك 
          <b-badge
            pill
            variant="light-danger"
          >
            {{ num_transactions_need_review }}
          </b-badge>
          معاملة بحاجة استدراك
        </h4>
        <hr />
        <div class="d-flex justify-content-end">

          <b-button variant="secondary" @click="onClickedCancel"> إلغاء </b-button>
        </div>
      </div>
    </b-modal>

    <!-- /TransactionsStatistics -->
  </b-container>
</template>

<script>
import {
  BRow,
  BButton,
  BCol,
  BContainer,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BBadge
} from "bootstrap-vue";
import profileCompletion from "../../components/ProfileCompletion.vue";
import statisticCard from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import visitsStatistics from "../../components/VisitsStatistics.vue";
import EventsLog from "@/components/log-timeline";
import { mapGetters } from "vuex";
import authHelpers from "@/utils/auth-helpers";

export default {
  components: {
    BRow,
    BButton,
    BCol,
    BContainer,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    visitsStatistics,
    statisticCard,
    profileCompletion,
    EventsLog,
    BBadge
  },
  data() {
    return {
      isTransactionsStatisticsShow: false ,
      num_transactions_need_review : null
    };
  },
  methods: {
    canNavigate() {
      return authHelpers.canNavigate("ngo-profile");
    },
    onClickedCancel(){
      localStorage.removeItem('fromLogin');
      this.isTransactionsStatisticsShow = false
    },
  },
  computed: {
    ...mapGetters("NgoProfile/mainNgoManage", ["logs", "loading"]),
  },

  created() {
    this.$store.dispatch("NgoProfile/mainNgoManage/getLog");
  },
  mounted(){
    this.num_transactions_need_review = authHelpers.getTransactionsNeedReview()
    console.log("num_transactions_need_review" , this.num_transactions_need_review , localStorage.getItem('fromLogin') )
    if(this.num_transactions_need_review != 0 && this.num_transactions_need_review != undefined){
      if(localStorage.getItem('fromLogin') == 'true'){
        this.isTransactionsStatisticsShow = true
      }
      else{
        this.isTransactionsStatisticsShow = false
      }
    }
  }
};
</script>
